export default __webpack_public_path__ + "static/media/Brow_3_C1.6c596530.svg";